import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal'

const DuplicatedModal = ({
  handleEdit = () => {},
  handleNew = () => {},
  info = {},
  translate = () => {},
}) => (
  <Modal
    renderButton={false}
    size='md'
    title={translate('missionMenu.duplicatedModal.title')}
    isOpen
    center={false}
    confirmButtonText={translate('missionMenu.duplicatedModal.edit')}
    cancelButtonText={translate('missionMenu.duplicatedModal.new')}
    onConfirm={handleEdit}
    onCloseModal={handleNew}
    className='mission-block-edit-modal'
  >
    <em className='left w-100'>
      {translate('missionMenu.duplicatedModal.text.1')}
    </em>
    <span>
      <em className='left w-100'>
        {translate('missionMenu.duplicatedModal.text.2')}
        <strong>{info.dsProfile}</strong>
      </em>
    </span>
    <em className='left w-100'>
      {translate('missionMenu.duplicatedModal.text.3')}
      <strong>{info.dsLdap}</strong>
    </em>
    <span>
      <em className='left w-100'>
        {translate('missionMenu.duplicatedModal.text.4')}
      </em>
    </span>
  </Modal>
)

DuplicatedModal.propTypes = {
  handleEdit: PropTypes.func.isRequired,
  handleNew: PropTypes.func.isRequired,
  info: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default DuplicatedModal
